import { Mapper } from '../services/mapper.service'
import { MappableModel } from './mappable-model'
import { Organization } from './organization'

export class Affiliation extends MappableModel {
  public child_organization: Organization
  public child_organization_id: number
  public credentials: any[]
  public id: number
  public parent_organization: Organization
  public parent_organization_id: number

  public deserialize(): void {
    this.child_organization = Mapper.as<Organization>(this.child_organization, Organization)
    this.parent_organization = Mapper.as<Organization>(this.parent_organization, Organization)
  }
}
